export default (state = {}, action) => {
  switch (action.type) {
    case 'ADD_NEW_USER_ASYNC':
      return Object.assign(state, action.payload);
    default:
      return state;
  }
};
